import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { SesionProvider } from './context/Sesion';
import { AuditoriaPage } from './pages/AuditoriaPage';
import { CargasPage } from './pages/CargasPage';
import { ClavesPage } from './pages/ClavesPage';
import { SinAccesoPage } from './pages/SinAccesoPage';
import { TablaEditarPage } from './pages/TablaEditarPage';
import { TablaPage } from './pages/TablaPage';
import { TablasPage } from './pages/TablasPage';
import { VersionesPage, VersionPage } from './pages/VersionesPage';

function Rutas() {
  return (
    <SesionProvider>
      {(s) =>
        s.me.roles.length === 0 ? (
          <SinAccesoPage alSalir={() => void s.salir()} />
        ) : (
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Navigate to="/tablas" replace />} />
              <Route path="tablas" element={<TablasPage />} />
              <Route path="tablas/nueva" element={<TablaEditarPage />} />
              <Route path="tablas/:tabla" element={<TablaPage />} />
              <Route path="tablas/:tabla/editar" element={<TablaEditarPage />} />
              <Route path="cargas" element={<CargasPage />} />
              <Route path="versiones" element={<VersionesPage />} />
              <Route path="versiones/:id" element={<VersionPage />} />
              <Route path="auditoria" element={<AuditoriaPage />} />
              <Route path="claves" element={<ClavesPage />} />
              <Route path="*" element={<Navigate to="/tablas" replace />} />
            </Route>
          </Routes>
        )
      }
    </SesionProvider>
  );
}

export function App() {
  return (
    <Routes>
      {/* Sin sesión: el back redirige aquí si el login falla. */}
      <Route path="/sin-acceso" element={<SinAccesoPage />} />
      <Route path="*" element={<Rutas />} />
    </Routes>
  );
}
